import { FormInputField, lt, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CreatePaymentPlanFormField } from '../types';

export const CreatePaymentPlanBillingModeField = () => {
    const localizeText = useLocalizeText();
    return (
        <FormInputField
            name={CreatePaymentPlanFormField.BillingMode}
            label={lt('CreatePaymentPlanFormBillingModeLabel')}
            defaultValue={localizeText({ textKey: TextKey.CreatePaymentPlanFormBillingModeReservationItems })}
            readOnly
        />
    );
};
